import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"w-divided-in",attrs:{"fluid":""}},[_vm._t("divided-in-content",function(){return [_c('w-row',{attrs:{"dense":""}},[_vm._t("default")],2)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }